import React, {Component} from "react";

class League extends Component {
	render() {
		const {children, league, checkHandler} = this.props;
		return (
			<div key={`live-league-${league.id}`}>
				<div className="thead">
					<div className="tr">
						<div className="th favorite"></div>
						<div className="th players" onClick={() => {checkHandler(league.id)}}>{league.name}</div>
						<div className="th score"></div>
					</div>
				</div>

				{children}
			</div>
		);
	}
}

export default League;


// WEBPACK FOOTER //
// ./src/app/pages/Live/modules/League.js